<header class="simple-layout__header-wrapper">
  <div class="simple-layout__header-sticky">
    <img class="simple-layout__emblem" src="assets/img/eagle.svg" alt="{{ 'common.emblemPoland' | translate }}" />
    <h1 class="simple-layout__title">
      <span class="helper__no-wrap mr-4">{{ 'common.appHeaderTitle1' | translate }}</span>
      <span class="helper__no-wrap">{{ 'common.appHeaderTitle2' | translate }}</span>
    </h1>
    <akmf-dropdown class="simple-layout__langs" *ngIf="languageList?.length > 1" container="body"
      [dropdownItems]="languageList" appBtnClassNamePostfix="-ci-invert" [addLeftMarginForFocus]="true"
      appBtnWithTextWidth="63px"></akmf-dropdown>
  </div>
</header>
<div class="simple-layout__content-wrapper">
  <main>
    <router-outlet></router-outlet>
  </main>
  <footer class="simple-layout__footer-wrapper">
    <div class="simple-layout__footer-controls-wrapper">
      <div class="simple-layout__footer-controls">
        <img class="simple-layout__logos" *mqIf="[ScreenSize.SmallDesktop, ScreenSize.Desktop]"
          src="assets/img/logos.png" [alt]="'common.logos' | translate">
        <div class="simple-layout__contact-us">
          <img *mqIf="[ScreenSize.SmallDesktop, ScreenSize.Desktop]" src="assets/img/KSeF_logo.png"
            [alt]="'common.appTitle' | translate">
          <img *mqIf="[ScreenSize.Mobile]" src="assets/img/KSeF_logo_mobile.png" [alt]="'common.appTitle' | translate">
          <a class="akmf-btn-main-invert mt-24 helper__no-wrap simple-layout__contact-us-btn" target="_blank"
            [href]="appConfigService.contactUs">{{
            'common.contactUs' | translate
            }}</a>
        </div>
      </div>
      <img class="simple-layout__logos" *mqIf="[ScreenSize.Mobile]" src="assets/img/logos.png"
        [alt]="'common.logos' | translate">
    </div>
  </footer>
</div>
